import { company } from '~/company/Company';

import { CityDrinksOnboarding } from './variants/CityDrinks/CityDrinksOnboarding';
import { DefaultOnboarding } from './variants/Default/DefaultOnboarding';
import { MCosmeticOnboarding } from './variants/MCosmetic';

export default company.match({
  citydrinks: CityDrinksOnboarding,
  mcosmetic: MCosmeticOnboarding,
  default: DefaultOnboarding,
});
